import React from "react";

export const ProfessionalBenefits = () => (
  <>
    <h4 style={{ marginTop: 40 }}>Professional Benefits</h4>
    <p style={{ fontSize: 15 }}>
      <li>
        Opportunity to learn first-hand what it’s like to be inside a seed-stage, Techstars-backed
        social venture
      </li>
      <li>Health, vision, dental insurance, paid holidays, PTO</li>
      <li>401k with 5% match</li>
      <li>Office in Denver, CO</li>
    </p>
  </>
);
